import React from "react";
import { Link } from "react-router-dom";
import { Alert, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import { Form } from "formik";

import Flexbar from "../Flexbar";
import Spinner from "../Spinner";
import InputField from "../input/InputField";
import Btn from "../Button";

/**
 * Renders the password reset request form
 * @param {Object} formikProps The formik props
 * @returns {Component} The component
 */
const PasswordResetRequestForm = ({
	values,
	errors,
	touched,
	handleChange,
	handleBlur,
	handleSubmit,
	isSubmitting
}) => 
	<Form>
		<FormGroup>
			<Label for="email">E-Mail</Label>
			<InputField type="text" name="email" placeholder="wolfang@goethe.ch" />
		</FormGroup>
		<Btn id="submitPasswordResetRequestForm" color="primary" type="submit" block loading={isSubmitting}>
			Passwort zurücksetzen
		</Btn>
		{errors.password_link_sending_failed && 
			<Alert className="my-2" color="danger">
				Der Link zum Zurücksetzen des Passworts konnte nicht an diese E-Mail
				Adresse gesendet werden.
			</Alert>
		}
	</Form>
;

export default PasswordResetRequestForm;
